import { render } from "./messengerListChat.vue?vue&type=template&id=b05c8266&scoped=true"
import script from "./messengerListChat.vue?vue&type=script&lang=js"
export * from "./messengerListChat.vue?vue&type=script&lang=js"

import "./messengerListChat.vue?vue&type=style&index=0&id=b05c8266&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b05c8266"]])

export default __exports__